import './ReportsPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';

import ActionMenu from 'components/ActionMenu';
import ActionMenuButton from 'components/ActionMenuButton';
import Content from 'components/Content';
import H1 from 'components/H1';
import H3 from 'components/H3';
import Icon from 'components/Icon';
import LoadingSpinner from 'components/LoadingSpinner';

import { updateTitle } from 'containers/App/store/actions';
import { emptyReports, getReports, updateReports } from './store/actions';

import { REPORT_TIMINGS } from './constants';

class ReportsPage extends React.Component {
    componentWillMount() {
        this.props.emptyReports();
        this.props.updateTitle('Reports');
        document.body.classList.add('reports-page');

        this.props.getReports();
    }

    componentWillUnmount() {
        document.body.classList.remove('reports-page');
    }

    _handleTriggerClick(event) {
        let target = event.target;

        while(target.getAttribute('class') == null || target.getAttribute('class').indexOf('report__action-menu') === -1) {
            target = target.parentNode;
        }

        target.querySelector('.action-menu').classList.add('active');
    }

    _handleTimingChange(timing, reportName) {
        let newReportsObj = update(this.props.reports, {});
        newReportsObj.timing[reportName] = timing;
        this.props.updateReports(newReportsObj);
    }

    _getReportValue(report, valueType) {
        console.log(report, valueType)
        let reports = this.props.reports.allReports[report];
        console.log(reports);
        let value = null;
        let stringValue = null;

        if(reports) {
            for(var i = 0, l = reports.length; i < l; i++) {
                if(reports[i].timePeriod === this.props.reports.timing[report]) {
                    value = reports[i].value;
                    if(reports[i].stringValue != null) {
                        stringValue = reports[i].stringValue;
                    }
                    break;
                }
            }
        }

        console.log(value, stringValue);

        if(valueType === 'number') {
            return value.toLocaleString()
        } else if(valueType === 'time') {
            if(value === -1) {
                // For averages with 0 watches
                value = 0;
            }
            if(value > 60) {
                let days = 0;
                let hours = parseInt(value / 3600, 10);
                if(hours > 24) {
                    days = parseInt(hours / 24, 10);
                    hours -= (days * 24);
                }
                let minutes = parseInt((value % 3600) / 60, 10);
                let valueString = `${days !== 0 ? days.toLocaleString() + ' day' : ''}${days > 1 ? 's' : ''}${days !== 0 ? ', ' : ''}${hours !== 0 ? hours + ' hour' : ''}${hours > 1 ? 's' : ''}${hours !== 0 && minutes !== 0 ? ', ' : ''}${minutes !== 0 ? minutes + ' minutes' : ''}`;
                return valueString;
            } else {
                return `${value} second${value !== 1 ? 's' : ''}`
            }
        } else if(valueType === 'popular') {
            if(value === 0) {
                return '0 Visits'
            } else {
                return `${stringValue}, ${value} Visit${value !== 1 ? 's' : ''}`;
            }
        } else if(valueType === 'percent') {
            return `${value}%`;
        }
    }

    render() {
        let reportArray = [
            {
                title: 'Total Assignments',
                modifier: 'Accepted',
                reportName: 'totalAssignments',
                icon: 'report--assignments',
                valueType: 'number',
                key: 0
            }, {
                title: 'Unique Assignments',
                modifier: 'Published',
                reportName: 'uniqueAssignments',
                icon: 'report--assignments',
                valueType: 'number',
                key: 1
            }, {
                title: 'Unique Users',
                modifier: 'Users',
                reportName: 'uniqueUsers',
                icon: 'report--groups',
                valueType: 'number',
                key: 2
            }, {
                title: 'Time Spent',
                modifier: '',
                reportName: 'timeSpentInAssignments',
                icon: 'report--time',
                valueType: 'time',
                key: 3
            }, {
                title: 'Average Time in Assignments',
                modifier: '',
                reportName: 'averageTimeSpentInAssignments',
                icon: 'report--time',
                valueType: 'time',
                key: 4
            }, {
                title: 'Average Time in Content',
                modifier: '',
                reportName: 'averageTimeSpentInContent',
                icon: 'report--time',
                valueType: 'time',
                key: 5
            }, {
                title: 'Unique Content',
                modifier: 'Created',
                reportName: 'uniqueContents',
                icon: 'report--content',
                valueType: 'number',
                key: 6
            }, {
                title: 'Popular Content',
                modifier: '',
                reportName: 'popularContents',
                icon: 'report--content',
                valueType: 'popular',
                key: 7
            }, {
                title: 'Percentage Pinpoints',
                modifier: '',
                reportName: 'percentAssignmentsPinPoints',
                icon: 'report--pinpoints',
                valueType: 'percent',
                key: 8
            }
        ];

        let { reports } = this.props;
        if(reports.isFetching === true || reports.allReports.length === 0) {
            return (
                <Content>
                    <LoadingSpinner />
                </Content>
            );
        } else {
            return (
                <Content>
                    <div className="report-list">
                        {reportArray.map((report, index) => {
                            return (
                                <section className="report" key={report.key}>
                                    <div className="report__icon">
                                        <Icon icon={report.icon} />
                                    </div>
                                    <div className="report__content">
                                        <H3>{report.title}</H3>
                                        <H1>
                                            {this._getReportValue(report.reportName, report.valueType)} {report.modifier}
                                        </H1>
                                        <div className="report__action-menu report__timing-menu">
                                            <div role="button"
                                                 className="report__trigger"
                                                 onClick={this._handleTriggerClick.bind(this)}>
                                                {REPORT_TIMINGS[reports.timing[report.reportName]]} <Icon icon="carrot-right"/>
                                            </div>
                                            <ActionMenu>
                                                {Object.keys(REPORT_TIMINGS).map((timing, index) => {
                                                    return (
                                                        <ActionMenuButton type="button"
                                                                          disabled={timing === reports.timing[report.reportName]}
                                                                          onClick={this._handleTimingChange.bind(this, timing, report.reportName)}
                                                                          key={index}>
                                                            {REPORT_TIMINGS[timing]}
                                                        </ActionMenuButton>
                                                    )
                                                })}
                                            </ActionMenu>
                                        </div>
                                    </div>
                                </section>
                            )
                        })}
                    </div>
                </Content>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        reports: state.reports
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        emptyReports: () => dispatch(emptyReports()),
        getReports: (callback) => dispatch(getReports(callback)),
        updateReports: (reportsObj) => dispatch(updateReports(reportsObj)),
        updateTitle: (title) => dispatch(updateTitle(title))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportsPage);



// WEBPACK FOOTER //
// ./src/containers/ReportsPage/index.js